var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1008",
    d: "M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5Z",
    stroke: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1009",
    d: "M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5Z",
    stroke: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5Z",
    fill: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.32 2.24C10.1882 2.14111 10 2.23519 10 2.4V3.5V4.6C10 4.76481 10.1882 4.85889 10.32 4.76L11.7867 3.66C11.8933 3.58 11.8933 3.42 11.7867 3.34L10.32 2.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 12V7H10.5V11.25L14 13.33L13.28 14.54L9 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 12V7H10.5V11.25L14 13.33L13.28 14.54L9 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1010",
    d: "M18 10.5C18 11.9834 17.5601 13.4334 16.736 14.6668C15.9119 15.9001 14.7406 16.8614 13.3701 17.4291C11.9997 17.9968 10.4917 18.1453 9.03682 17.8559C7.58196 17.5665 6.24559 16.8522 5.1967 15.8033C4.14781 14.7544 3.4335 13.418 3.14411 11.9632C2.85472 10.5083 3.00325 9.00032 3.5709 7.62987C4.13856 6.25943 5.09985 5.08809 6.33322 4.26398C7.56659 3.43987 9.01664 3 10.5 3V4.03363C9.22107 4.03363 7.97087 4.41287 6.90748 5.12341C5.84409 5.83394 5.01527 6.84385 4.52585 8.02543C4.03643 9.207 3.90837 10.5072 4.15788 11.7615C4.40738 13.0159 5.02325 14.1681 5.92758 15.0724C6.83192 15.9768 7.98412 16.5926 9.23847 16.8421C10.4928 17.0916 11.793 16.9636 12.9746 16.4741C14.1561 15.9847 15.1661 15.1559 15.8766 14.0925C16.5871 13.0291 16.9664 11.7789 16.9664 10.5H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1011",
    d: "M17.9648 9.77445C17.9153 9.26539 17.8139 8.76273 17.6621 8.27431L16.6751 8.58105C16.8059 9.00215 16.8934 9.43554 16.936 9.87444L17.9648 9.77445Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1012",
    d: "M17.3844 7.52434C17.1723 7.03353 16.9083 6.56681 16.5969 6.13215L15.7566 6.73411C16.0251 7.10887 16.2527 7.51127 16.4356 7.93444L17.3844 7.52434Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1013",
    d: "M16.0401 5.44455C15.6703 5.03931 15.2571 4.67587 14.8081 4.36075L14.2144 5.20684C14.6015 5.47853 14.9577 5.79188 15.2766 6.14127L16.0401 5.44455Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1014",
    d: "M14.0593 3.8984C13.5765 3.63805 13.0665 3.43146 12.5385 3.28235L12.2576 4.27707C12.7128 4.40563 13.1525 4.58374 13.5688 4.80821L14.0593 3.8984Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOff);
export default __webpack_public_path__ + "static/media/holdOff.be2a2e1770413616cdde149c2a4c7249.svg";
export { ForwardRef as ReactComponent };